define.alias("shared/helpers/are-equal", "settings/helpers/are-equal");